<div
  #modal
  class="modal fade"
  id="myModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          id='addSubscriptionModalDialogClose'
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" id="myModalLabel">
          {{ data ? data.title : "Add subscription" }}
        </h4>
      </div>
      <div class="modal-body">
        <div *ngIf="show">
          <form (ngSubmit)="edit(form)" #form="ngForm">
            <div *ngIf="plansList" class="form-group">
              <label for="planId-dropdown">Subscription type</label>
              <select
                id="planId-dropdown"
                [(ngModel)]="item.planId"
                name="planId"
                class="form-control"
                #planId="ngModel"
                required
              >
                <option *ngFor="let plan of plansList" [value]="plan.id"
                  ><span>{{ plan.name }} </span></option
                >
              </select>
              <small
                class="text-danger"
                *ngIf="(planId.touched || planId.dirty) && !planId.valid"
              >
                Subscription type is required.
              </small>
            </div>

            <div class="form-group">
              <label for="page-edit-invoice">Invoice ID</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="item.invoiceId"
                name="invoiceId"
                #invoiceId="ngModel"
                class="form-control"
                id="page-edit-invoice"
                pattern="^in_[a-zA-Z0-9]+$"
                required
                [readonly]="loading"
              />
              <small
                class="text-danger"
                *ngIf="
                  (invoiceId.touched || invoiceId.dirty) && !invoiceId.valid
                "
              >
                <span *ngIf="invoiceId.errors && invoiceId.errors['required']">Invoice ID is required.</span>
                <span *ngIf="invoiceId.errors && invoiceId.errors['pattern']">
                  Invoice ID must be a valid Stripe invoice ID (starts with <code>in_</code>).
                </span>
              </small>
            </div>

            <div class="form-group">
              <label for="page-edit-subscription">Subscription ID</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="item.subscriptionId"
                name="subscriptionId"
                #subscriptionId="ngModel"
                class="form-control"
                id="page-edit-subscription"
                pattern="^sub_[a-zA-Z0-9]+$"
                required
                [readonly]="loading"
              />
              <small
                class="text-danger"
                *ngIf="
                  (subscriptionId.touched || subscriptionId.dirty) &&
                  !subscriptionId.valid
                "
              >
                <span *ngIf="subscriptionId.errors && subscriptionId.errors['required']">Subscription ID is required.</span>
                <span *ngIf="subscriptionId.errors && subscriptionId.errors['pattern']">
                  Subscription ID must be a valid Stripe subscription ID (starts with <code>sub_</code>).
                </span>
              </small>
            </div>

            <div class="form-group">
              <label for="member-edit-name">End Date</label>
              <ch-datepicker
                datetime="true"
                (onChange)="endDateChanged($event)"
                [date]="item.endsAt"
                id="subscription-end-date-picker"
              ></ch-datepicker>
              <input
                type="hidden"
                [(ngModel)]="item.endsAt"
                name="endsAt"
                #endsAt="ngModel"
                required
              />
              <small
                class="text-danger"
                *ngIf="(endsAt.touched || endsAt.dirty) && !endsAt.valid"
              >
                End Date is invalid.
              </small>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button
          id='addSubscriptionModalDialogAdd'
          type="button"
          class="btn btn-success default-btn"
          (click)="add()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/add-subscription-modal-dialog/add-subscription-modal-dialog.component.html